import React, { useEffect, useState } from 'react';
import {getVideoFrameImage} from "utils/tool";
import VideoPreview from 'components/order-management/base/VideoPreview'
import {Image} from "antd";


interface IComponentProps {
  data: any;
}
const Attachments: React.FC<IComponentProps> = (props) => {
  const { data } = props
  const [videoWithPic, setVideoWithPic ] = useState<any>([]);
  const { images, videos } = data

  useEffect(() => {
    // if (videos?.length > 0) {
    //   const promiseList = videos.map((item: any) => getVideoFrameImage(item))
    //   Promise.all(promiseList).then((pis) => {
    //     const arr = pis.map((item: any, index: number) => ({
    //       picUrl: item,
    //       videoUrl: videos[index],
    //     }))
    //     setVideoWithPic(arr)
    //   })
    // }
  }, []);


  return (
    <>
      <div style={{display: 'flex', flexWrap: 'wrap'}}>
        {images?.map((image: any, i: number) => {
          return <div style={{marginLeft: '12px'}}><Image style={{width: '102px', height: '102px'}} src={image}></Image></div>
        })}
      </div>

      <div style={{marginTop: '10px',display: 'flex', flexWrap: 'wrap' }}>
        {
          videos?.map((item: any, index: number) => {
            return <VideoPreview style={{ marginLeft: '12px' }} value={item} ></VideoPreview>
          })
        }
      </div>
    </>
  );
};

export default Attachments;
